import { creatorbase } from '@round/api';
import { useInvalidateAggregatedPostStats } from '@round/creatorbase-helpers/api-hooks';
import useInvalidateReportCampaigns from '../Campaigns/hooks/useInvalidateReportCampaigns';
import useReportId from './useReportId';

export function useRefreshReportProjects() {
    const reportId = useReportId();
    const invalidateAggregatedPostStats = useInvalidateAggregatedPostStats();
    const invalidateReportCampaigns = useInvalidateReportCampaigns();

    return () => {
        // Campaigns refetch, and projects follow off the new campaign id set. Report-level stats
        // are invalidated directly. Per-campaign stats are intentionally left alone: a campaign that
        // persists across the refresh keeps valid cached stats (changing the project set doesn't
        // affect them), and newly-added campaigns fetch fresh via their own enabled query.
        creatorbase.platforms.forEach((platform) => invalidateReportCampaigns(platform));
        if (reportId) {
            creatorbase.platforms.forEach((platform) =>
                invalidateAggregatedPostStats({ platform, report_id: reportId }).catch(() => {})
            );
        }
    };
}
